import * as types from "./actionTypes";
import { cloneDeep } from "../../utils/utils";
import { initialState } from "./initialState";

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.AUTH_API_LOGIN_SUCCESS:
      return setLoggedInUser(state, action.payload);
    case types.AUTH_API_LOGOUT:
    case types.AUTH_API_LOGIN_FAILURE:
      return initialState;
    default:
      return setUser(state);
  }
};

const setLoggedInUser = (state, payload) => {
  const clonedState = cloneDeep(state);
  clonedState.isLoggedIn = true;
  clonedState.user = {
    ...clonedState.user,
    ...payload,
  };
  return clonedState;
};

const setUser = (state) => {
  const user = JSON.parse(sessionStorage.getItem("user"));
  const isLoggedIn = user ? Boolean(user.id) : false;
  if (isLoggedIn && !state.user.id) {
    const clonedState = cloneDeep(state);
    clonedState.isLoggedIn = true;
    clonedState.user = user;

    return clonedState;
  }
  return initialState;
};

export default reducer;
